import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=3dd09502"
import script from "./CustomerAddress.vue?vue&type=script&lang=js"
export * from "./CustomerAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd09502')) {
      api.createRecord('3dd09502', component.options)
    } else {
      api.reload('3dd09502', component.options)
    }
    module.hot.accept("./CustomerAddress.vue?vue&type=template&id=3dd09502", function () {
      api.rerender('3dd09502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerAddress.vue"
export default component.exports